import { CustomRadioGroup } from '../../../../components/CustomRadioGroup.tsx'
import { I18n } from '../../../../components/I18n.tsx'
import { ids } from '../../../../ids.ts'
import type { ReportFormStep } from '../CreateReportForm.tsx'
import type { ReportTypeSelection } from '../reportTypes.tsx'

// Choosing a type rebuilds the form for that type, so this step has no form fields of its own.
export const selectReportTypeStep = (selection: ReportTypeSelection): ReportFormStep => ({
	id: 'reportType',
	label: <I18n i18nKey={($) => $.reports.form.steps.reportType.label} />,
	shortDescription: <I18n i18nKey={($) => $.reports.form.steps.reportType.shortDescription} />,
	longDescription: <I18n i18nKey={($) => $.reports.form.steps.reportType.longDescription} />,
	form: <SelectReportTypeStep {...selection} />,
	fieldsToValidate: [],
	disableNext: !selection.selected,
})

const SelectReportTypeStep = ({ options, selected, onSelect }: ReportTypeSelection) => (
	<CustomRadioGroup
		data-ta={ids.reports.form.reportType}
		options={options.map((reportType) => ({
			value: reportType.type,
			label: <I18n i18nKey={($) => $.reports.form.reportTypes[reportType.type]} />,
			icon: reportType.icon,
		}))}
		value={selected}
		onChange={onSelect}
	/>
)
